import { changeOnboardingStage, changeOnboardingSubtask } from '../api/api';
import { getOnboardingConfig } from '../api/onboardingVariant';

export const onboardingUnblockPublish = async (): Promise<void> => {
    const { publishStageSlug, stageSlugs, subtaskSlugs } = getOnboardingConfig();

    await Promise.all(subtaskSlugs.map((slug) => changeOnboardingSubtask({ slug, value: true })));
    await Promise.all(
        stageSlugs
            .filter((slug) => slug !== publishStageSlug)
            .map((slug) => changeOnboardingStage({ slug, value: true }))
    );
};
